<hpf-gallery-form
        *ngIf="gallery"
        [gallery]="gallery"
        (create)="onCreate($event)"
    ></hpf-gallery-form>
<div *ngIf="!gallery" class="my-5 text-center">
    <nz-spin nzSimple></nz-spin>
</div>